import React from 'react'

const ModuleMenu = (props) => {
  if (typeof props.modules !== typeof []) return <div></div>;
  return (
    <div className="menu-item ModuleMenu">
      <div className='select-label'>
        Lesson Select:
      </div>
      <select onChange={
        (e) => {

          props.controller.setModuleIndex(e.target.value)
        }
      }
              value={props.moduleIndex}
      >
        <option
          key={'moduleopen-' + -1}
          value={-1}
          className={`item ${props.controller.getModuleIndex() === -1 ? 'active' : ''}`}>
          Menu
        </option>
        {

          props.modules.map((el, i) => {
            return (<option
              key={'moduleopen-' + i}
              value={i}
              className={`item ${props.controller.getModuleIndex() === i ? 'active' : ''}`}>
              {i} - {el.name}
            </option>)
          })
        }
      </select>
    </div>
  );
}
const StepMenu = (props) => {
  if (typeof props.steps !== typeof []) return <div></div>;
  return (
    <div className="menu-item StepMenu">
      <div className='select-label'>
        Section Select:
      </div>
      <select onChange={
        (e) => {
          props.controller.setStepIndex(e.target.value)
        }}
              value={props.stepIndex}
      >
        {
          props.steps.map((el, i) => {
            return (<option
              value={i}
              key={`${props.controller.getModuleIndex}-${i}`}
              className={`item ${props.controller.getStepIndex() === i ? 'active' : ''}`}>
              Step {i} - {el.type}
            </option>)
          })
        }
      </select>
    </div>
  );
}

export default function QAMenu(props) {
  return (
    <div className="QAMenu">

      <div className="left-section">
        <div className="ai-logo"></div>
      </div>
      <div className="right-section">
        <ModuleMenu moduleIndex={props.moduleIndex} modules={props.modules} controller={props.controller}/>
        {(props.steps || []).length > 0 &&
        <StepMenu stepIndex={props.stepIndex} steps={props.steps} controller={props.controller}/>}
        {(props.steps || []).length > 0 && <div className="menu-item">
          <div className="qa-button" onClick={props.controller.stepComplete}>Complete Step</div>
        </div>}
        {(props.steps || []).length > 0 && <div className="menu-item">
          <div className="qa-button" onClick={props.controller.resetStep}>Reset Step</div>
        </div>}
        {/* {<div className="menu-item">
          <div className="qa-button"
               onClick={props.controller.toggleEditMode}>{props.editMode ? 'Close Editor' : 'Open Editor'}</div>
        </div>} */}
      </div>
      <div className="box-label">Review Toolbox</div>

    </div>
  )
}
